var TEMPLATE_URL = require('./purchase.premium.html');

angular.module('ikeweb.user').directive('purchasePremium',
    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {},
            controller: 'PurchasePremiumController',
            controllerAs: 'ctrl'
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/purchase.premium.directive.js
// module id = 504
// module chunks = 0